import { get, isEqual } from "lodash";

import store from "store/store";
import {
	setAwardListActualFacets,
	setAwardListFacetedSearchKeys,
	setProjectListActualFacets,
	setProjectListFacetedSearchKeys,
	setProposalListActualFacets,
	setProposalListFacetedSearchKeys,
} from "store/actions/facetedSearch";


const currentValue = {
	searchKeys: {
		awards: [],
		projects: [],
		proposals: [],
	},
	actualFacets: {
		awards: {},
		projects: {},
		proposals: {},
	},
};

const set = {
	searchKeys: {
		awards: setAwardListFacetedSearchKeys,
		projects: setProjectListFacetedSearchKeys,
		proposals: setProposalListFacetedSearchKeys,
	},
	actualFacets: {
		awards: setAwardListActualFacets,
		projects: setProjectListActualFacets,
		proposals: setProposalListActualFacets,
	},
};

const handleInitFacetedSearch = (type) => {
	let previousValue = currentValue.searchKeys[type];
	currentValue.searchKeys[type] = get(store.getState(), `columns.${type}.availableColumns`, []);

	if (!isEqual(previousValue, currentValue.searchKeys[type])) {
		set.searchKeys[type](currentValue.searchKeys[type]);
	}
};

const handleUpdateActualFacets = (type) => {
	let previousValue = currentValue.actualFacets[type];
	currentValue.actualFacets[type] = get(store.getState(), `${type}.content.search`, {});

	if (!isEqual(previousValue, currentValue.actualFacets[type])) {
		set.actualFacets[type](currentValue.actualFacets[type]);
	}
};

export const subscribeFacetedSearch = () => {
	store.subscribe(() => handleInitFacetedSearch("awards"));
	store.subscribe(() => handleInitFacetedSearch("projects"));
	store.subscribe(() => handleInitFacetedSearch("proposals"));

	store.subscribe(() => handleUpdateActualFacets("awards"));
	store.subscribe(() => handleUpdateActualFacets("projects"));
	store.subscribe(() => handleUpdateActualFacets("proposals"));
};
